import Logos from '../../Assets/Logos.png'
import { Link } from 'react-router-dom'
import { inProcess } from '../../Redux/Features/Quiz/quizStateSlice'
import { useDispatch } from 'react-redux'
import './Home.css'

const Home = () => {
  const dispatch = useDispatch()

  return (
    <div className='mw-1340'>
      <div className='home__content'>
        <div className='img-container'>
          <img src={Logos} alt='Logos' />
        </div>
        <div>
          <h1>
            Тестові завдання для перевірки рівня знань сержантського складу
            Збройних Сил України з питань міжнародного гуманітарного права (МГП)
            в умовах міжнародного збройного конфлікту (МЗК)
          </h1>
        </div>
        <div className='list'>
          <p>I. Принципи МГП. Джерела МГП</p>
          <p>II. Правила поводження із особами, які знаходяться під захистом</p>
          <p>III. Засоби та методи ведення бойових дій</p>
          <p>IV. Відповідальність за порушення норм МГП</p>
          <p>V. Розслідування порушень норм МГП та докази з полю бою</p>
          <p>VI. Медіа грамотність та МГП</p>
        </div>
        <div className='info'>
          <p>
            Щоб розпочати – натисніть кнопку “Розпочати тестування”, вам буде
            запропоновані питання з різними варіантами відповідей, з яких ви має
            обрати один правильний. Для успішного проходження тестування ви
            маєте набрати не менше, ніж 48 балів, що складатиме 80% від
            загальної кількості питань (60)
          </p>
          <Link
            to='/quiz'
            onClick={() => {
              dispatch(inProcess())
              localStorage.removeItem('result')
              window.scrollTo(0, 0)
            }}
          >
            Розпочати тестування
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Home
